import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const MAX_COMPARISON_TYRES = 4;
const STORAGE_KEY = '@porsche/comparison-tyres';

const useComparisonStore = create(
  persist(
    (set, get) => ({
      // State
      tyres: [],
      isOpen: false,

      // Actions
      addTyre: (tyre) => {
        if (!tyre || !tyre._id) return false;

        const { tyres } = get();

        // Check if already exists
        if (tyres.some((t) => t._id === tyre._id)) {
          return true;
        }

        // Check maximum limit
        if (tyres.length >= MAX_COMPARISON_TYRES) {
          return false;
        }

        set({ tyres: [...tyres, tyre] });
        return true;
      },

      removeTyre: (tyreId) => {
        set((state) => ({
          tyres: state.tyres.filter((t) => t._id !== tyreId),
        }));
      },

      clear: () => {
        set({ tyres: [] });
      },

      togglePanel: () => {
        set((state) => ({ isOpen: !state.isOpen }));
      },

      openPanel: () => {
        set({ isOpen: true });
      },

      closePanel: () => {
        set({ isOpen: false });
      },

      // Selectors (computed values)
      isInComparison: (tyreId) => {
        return get().tyres.some((t) => t._id === tyreId);
      },

      isFull: () => {
        return get().tyres.length >= MAX_COMPARISON_TYRES;
      },

      count: () => {
        return get().tyres.length;
      },
    }),
    {
      name: STORAGE_KEY,
      partialize: (state) => ({ tyres: state.tyres }), // Only persist tyres, not isOpen
    }
  )
);

export default useComparisonStore;




